import React from 'react';
import {
  required,
  Edit,
  TextInput,
  SimpleForm,
  TranslatableInputs,
  ReferenceInput,
  SelectInput,
  BooleanInput
} from 'react-admin';

// own ui
import EditTitle from '../../ui/edit-title';
import CustomEditToolbar from '../../ui/custom-edit-toolbar';

const validateCategoryAttractive = required('Selecione uma categoria de atrativo!');
const validateName = [required('Digite o nome!')];

const SubCategoryAttractiveEdit = (props) => (
  <Edit {...props} title={ <EditTitle subtitle="Editar Sub Categoria de Atrativo: " value="name" subvalue="pt_br" /> }>
    <SimpleForm redirect="/sub-category-attractive" toolbar={<CustomEditToolbar />} >
      <TextInput source="id" label="Id" disabled />
      <ReferenceInput label="Categoria de Atrativo" source="category_attractive_id" fullWidth={true} reference="category-attractive" validate={validateCategoryAttractive}>
        <SelectInput optionText="name.pt_br" optionValue="id" />
      </ReferenceInput>
      <TranslatableInputs locales={['pt_br', 'en_us']} defaultLocale="pt_br">
        <TextInput source="name" label="Nome" fullWidth={true} validate={validateName} />
      </TranslatableInputs>
      <br/>
      <BooleanInput source="active" label="Ativo" />
    </SimpleForm>
  </Edit>
);

export default SubCategoryAttractiveEdit;
